import { render, staticRenderFns } from "./2021-4-22-code.vue?vue&type=template&id=34553ed8&scoped=true&"
import script from "./2021-4-22-code.vue?vue&type=script&lang=ts&"
export * from "./2021-4-22-code.vue?vue&type=script&lang=ts&"
import style0 from "./2021-4-22-code.vue?vue&type=style&index=0&id=34553ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34553ed8",
  null
  
)

export default component.exports